import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RequestStatus } from '../../helpers/request'
import { createUserAgreement, requestUserAgreementDraft } from './actions'
import {
    getUserAgreements,
    getUserAgreementsDraft,
    getUserAgreementsDraftRequestStatus,
    getUserAgreementsRequestStatus,
} from './selectors'

// Draft
export const useUserAgreementDraftRequestStatus = () =>
    RequestStatus.status(useSelector(getUserAgreementsDraftRequestStatus))

/**
 * @deprecated Use useGetDraftUserAgreements (/store/user-agreement/hooks/use-get-draft-user-agreements.ts) instead
 */
export const useUserAgreementDraft = ({ userAgreementType }) => {
    const dispatch = useDispatch()
    const { shouldFetch } = useUserAgreementDraftRequestStatus()
    const userAgreementDraft = useSelector(getUserAgreementsDraft)

    useEffect(() => {
        if (shouldFetch) dispatch(requestUserAgreementDraft({ userAgreementType }))
    }, [dispatch, shouldFetch, userAgreementType])

    return userAgreementDraft.agreement
}

// Accepted
export const useUserAgreementRequestStatus = () => RequestStatus.status(useSelector(getUserAgreementsRequestStatus))

export const useUserAgreement = ({ userAgreementType }) => {
    const dispatch = useDispatch()
    const { shouldFetch } = useUserAgreementRequestStatus()
    const userAgreement = useSelector(getUserAgreements)

    useEffect(() => {
        if (shouldFetch) dispatch(requestUserAgreementDraft({ userAgreementType }))
    }, [dispatch, shouldFetch, userAgreementType])

    return userAgreement
}

export const useCreateUserAgreement = ({ userAgreementType }) => {
    const dispatch = useDispatch()

    return useCallback(() => dispatch(createUserAgreement({ userAgreementType })), [dispatch, userAgreementType])
}
